// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__YJvR3","text":"SelectPayment_text__2PBaU","title":"SelectPayment_title__2yBti","btn":"SelectPayment_btn__1DDoL"};